import React from 'react';
import { motion } from 'framer-motion';
export type BreastSide = 'left' | 'right' | 'both' | null;
export function BreastDiagramSelector({
  selected,
  onSelect
}: {
  selected: BreastSide;
  onSelect: (side: 'left' | 'right') => void;
}) {
  const isLeftSelected = selected === 'left' || selected === 'both';
  const isRightSelected = selected === 'right' || selected === 'both';
  return <div className="w-full max-w-[280px] mx-auto aspect-[4/3] relative" data-id="element-89">
      <svg viewBox="0 0 400 300" className="w-full h-full drop-shadow-sm" data-id="element-90">
        {/* Base body outline */}
        <path d="M 50 50 Q 200 80 350 50 L 380 300 L 20 300 Z" fill="#F8FAFC" stroke="#E2E8F0" strokeWidth="4" strokeLinejoin="round" data-id="element-91" />

        {/* Collarbones */}
        <path d="M 100 80 Q 200 110 300 80" fill="none" stroke="#CBD5E1" strokeWidth="3" strokeLinecap="round" data-id="element-92" />
        <path d="M 200 110 L 200 130" fill="none" stroke="#CBD5E1" strokeWidth="3" strokeLinecap="round" data-id="element-93" />

        {/* Right Breast (Patient's Right, Viewer's Left) */}
        <motion.g onClick={() => onSelect('right')} className="cursor-pointer" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} data-id="element-94">
          <path d="M 60 160 C 60 260, 180 280, 190 160 C 190 120, 100 120, 60 160 Z" fill={isRightSelected ? '#FFE4E6' : '#FFFFFF'} stroke={isRightSelected ? '#F43F5E' : '#CBD5E1'} strokeWidth={isRightSelected ? '4' : '3'} className="transition-colors duration-200" data-id="element-95" />
          {/* Nipple/Areola */}
          <circle cx="125" cy="200" r="15" fill={isRightSelected ? '#FDA4AF' : '#F1F5F9'} data-id="element-96" />
          <circle cx="125" cy="200" r="4" fill={isRightSelected ? '#F43F5E' : '#CBD5E1'} data-id="element-97" />

          {/* Label */}
          <text x="125" y="250" textAnchor="middle" fill={isRightSelected ? '#F43F5E' : '#94A3B8'} fontSize="14" fontWeight="600" className="select-none pointer-events-none" data-id="element-98">
            RIGHT
          </text>
        </motion.g>

        {/* Left Breast (Patient's Left, Viewer's Right) */}
        <motion.g onClick={() => onSelect('left')} className="cursor-pointer" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} data-id="element-99">
          <path d="M 340 160 C 340 260, 220 280, 210 160 C 210 120, 300 120, 340 160 Z" fill={isLeftSelected ? '#FFE4E6' : '#FFFFFF'} stroke={isLeftSelected ? '#F43F5E' : '#CBD5E1'} strokeWidth={isLeftSelected ? '4' : '3'} className="transition-colors duration-200" data-id="element-100" />
          {/* Nipple/Areola */}
          <circle cx="275" cy="200" r="15" fill={isLeftSelected ? '#FDA4AF' : '#F1F5F9'} data-id="element-101" />
          <circle cx="275" cy="200" r="4" fill={isLeftSelected ? '#F43F5E' : '#CBD5E1'} data-id="element-102" />

          {/* Label */}
          <text x="275" y="250" textAnchor="middle" fill={isLeftSelected ? '#F43F5E' : '#94A3B8'} fontSize="14" fontWeight="600" className="select-none pointer-events-none" data-id="element-103">
            LEFT
          </text>
        </motion.g>
      </svg>
      <p className="text-center text-xs text-stone-400 mt-2" data-id="element-104">
        Tap a side to select
      </p>
    </div>;
}